const scope_0 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
const scope_1 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/7e91bfcd41ea1b74c0901e0233e1e24d.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    